// @flow

import apiFetch from 'shared/libs/apiFetch';

import { memoizedNewsSelector } from './selector';
import type { NewsSelectorResult, FetchNewsParamsType } from './types';

const fetchNews = ({ url, locale, params, isFormatImg = false }: FetchNewsParamsType): NewsSelectorResult => {
  return apiFetch({ url, locale, params })
    .then((data) => data.json())
    .then((data) => memoizedNewsSelector(data, { locale, isFormatImg }))
    .catch((error) => ({ error }));
};

export default fetchNews;
